// ======================================================================
// File Name       : EnterpriseListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EnterpriseTreeContainer from './EnterpriseTreeContainer';
import EnterpriseNoHierarchyContainer from './EnterpriseNoHierarchyContainer';
import EnterpriseSearchForm from '../../components/enterprise/EnterpriseSearchForm';
import ModalConductor from '../../components/modal/ModalConductor';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import DialogConfirm from '../../components/DialogConfirm';
import { BULK_EXPORT, MSG_DEL_ENTERPRISE } from '../../constants/MessageTemplate';
import * as enterpriseActions from '../../actions/EnterpriseAction';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { ENTERPRISE_EDIT } from '../../constants/FunctionConstants';
import {
  BILLING_SYSTEM_REGISTER_FLAG_STATUS,
  ENTERPRISE_LAYER_L1,
} from '../../constants/EnterpriseConstants';
import * as utils from '../../utils';
import * as modalActions from '../../actions/ModalAction';
import * as ModalIds from '../../constants/ModalIds';

class EnterpriseContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      isAllowShowSearchMessage: false,
      resultList: [],
      showDelete: false,
      showExportConfirm: false,
      enterpriseCd: '',
    };
    this.dismissMessage = this.dismissMessage.bind(this);
    this.updateSearchResult = this.updateSearchResult.bind(this);
    this.onOkDelete = this.onOkDelete.bind(this);
    this.onOkExport = this.onOkExport.bind(this);
    this.handleExportCSV = this.handleExportCSV.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handlePreCancelBtn = this.handlePreCancelBtn.bind(this);
    this.handleEditBtn = this.handleEditBtn.bind(this); // Step 12.0.0 TAS-18710
  }
  componentWillMount() {
    this.formSubmit = this.formSubmit.bind(this);
    const { dispatch } = this.props;
    dispatch(enterpriseActions.init());
  }
  formSubmit() {
    this.treeRef.getWrappedInstance().handleSearchBtn();
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false, resultList: [] });
  }

  updateSearchResult(isAllowShowSearchMessage, resultList) {
    this.setState({ isAllowShowSearchMessage, resultList });
  }

  handleDelete(menuData, { callbackData = {} } = {}) {
    const { enterpriseCd } = callbackData;
    this.setState({ showDelete: true, enterpriseCd });
  }

  onOkDelete() {
    const { dispatch } = this.props;
    dispatch(enterpriseActions.deleteEnterprise(this.state.enterpriseCd));
    this.setState({ showDelete: false });
  }

  onOkExport() {
    const { dispatch } = this.props;
    dispatch(enterpriseActions.exportCSV());
    this.setState({ showExportConfirm: false });
  }

  handleExportCSV() {
    this.setState({ showExportConfirm: true });
  }

  handlePreCancelBtn() {
    const { dispatch } = this.props;
    dispatch(modalActions.openModal(ModalIds.ENTERPRISE_REASON_FOR_CANCEL));
  }

  // Step 12.0.0 TAS-18710 START
  handleEditBtn() {
    const { dispatch } = this.props;
    dispatch(modalActions.openModal(ModalIds.ENTERPRISE_EDIT));
  }
  // Step 12.0.0 TAS-18710 END

  render() {
    const { resultList, isAllowShowSearchMessage } = this.state;
    const { enterpriseNotChild, displayUserType, readOnlyFlag, rootFlag, editingEnterprise, isEnterpriseNotChild } =
      this.props;
    const canEditEnterprise = canAccessRoute(ENTERPRISE_EDIT);
    // Step 11.2.0 START
    // Step 12.0.0 TAS-18710 START
    const isShowPreCancelBtn =
      ((utils.isSuperUserL0(displayUserType) && !readOnlyFlag)
        || (utils.isSuperUserL1(displayUserType) && rootFlag && !readOnlyFlag))
      && isEnterpriseNotChild
      && editingEnterprise.enterpriseLayer === ENTERPRISE_LAYER_L1
      && !editingEnterprise.enterpriseDeleteFlag
      && editingEnterprise.billingSystemRegisterFlag !== BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED;
    // Step 12.0.0 TAS-18710 END
    // Step 11.2.0 END
    return (
      <div>
        <MessageSearch
          recordNum={resultList && resultList.length ? resultList.length : 0}
          resultList={resultList}
          isAllowShowSearchMessage={isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Header name="企業情報" />
        {/* Step10.2.0 START */}
        {isEnterpriseNotChild && (
          <>
            <EnterpriseNoHierarchyContainer
              enterprise={editingEnterprise}
              isShowPreCancelBtn={isShowPreCancelBtn}
              rootFlag={rootFlag}
              handlePreCancelBtn={this.handlePreCancelBtn}
              handleEditBtn={this.handleEditBtn}
            />
            <ModalConductor />
          </>
        )}
        {!isEnterpriseNotChild && (
          <>
            <EnterpriseSearchForm formSubmit={this.formSubmit} />
            <EnterpriseTreeContainer
              ref={(treeRef) => {
                this.treeRef = treeRef;
              }}
              updateSearchResult={this.updateSearchResult}
              handleExportBtn={this.handleExportCSV}
              handleDelete={this.handleDelete}
              canEditEnterprise={canEditEnterprise}
            />
            <DialogConfirm
              showModal={this.state.showDelete}
              onCancel={() => this.setState({ showDelete: false })}
              content={MSG_DEL_ENTERPRISE}
              onOK={this.onOkDelete}
              animation={false}
            />
            <DialogConfirm
              showModal={this.state.showExportConfirm}
              onCancel={() => this.setState({ showExportConfirm: false })}
              content={BULK_EXPORT}
              onOK={this.onOkExport}
              animation={false}
            />
            <ModalConductor />
          </>
        )}
        {/* Step10.2.0 END */}
      </div>
    );
  }
}

EnterpriseContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  bySecernId: PropTypes.shape().isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { isEnterpriseNotChild, editingEnterprise } = state.enterprise;
  const { userInfo: { displayUserType }, readOnlyFlag, rootFlag, usageSettingInfo } = state.authed.authedUser;
  return {
    displayUserType,
    readOnlyFlag,
    rootFlag,
    isEnterpriseNotChild,
    editingEnterprise,
    usageSettingInfo,
  };
};

export default connect(mapStateToProps)(EnterpriseContainer);
